export default __webpack_public_path__ + "images/8bf64545bd49e53df2ff3c507acb4004-tournament.jpg";